import React from "react";

import { Tooltip } from "@mui/material";
import classnames from "classnames";

import useStyles from "../styles";
import { PrivatePolicyFlagButton } from "../types";

export const Text: React.FC = ({ children }) => {
  const classes = useStyles();

  return <span className={classes.text}>{children}</span>;
};

export const Strong: React.FC = ({ children }) => {
  const classes = useStyles();

  return <span className={classnames(classes.text, classes.strong)}>{children}</span>;
};

export const FlagButton: React.FC<PrivatePolicyFlagButton> = (props) => {
  const { code, label, onClick } = props;
  const classes = useStyles();

  return (
    <div onClick={onClick} className={classes.flagContainer}>
      <Tooltip title={label}>
        <img key={code} loading="lazy" src={`https://flagcdn.com/32x24/${code}.png`} alt={code} />
      </Tooltip>
    </div>
  );
};
